import Button, { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

interface BaseButtonProps extends ButtonProps {
    loading?: boolean;
}

export default function BaseButton({
    children,
    variant = 'contained',
    color = 'primary',
    loading = false,
    disabled = false,
    ...props
}: BaseButtonProps) {
    return (
        <Button
            variant={variant}
            color={color}
            sx={{ pb: 0.6, fontWeight: 'bold' }}
            disabled={loading || disabled}
            {...props}
        >
            {loading ? <CircularProgress size={24} color="inherit" /> : children}
        </Button>
    );
}
